import { ArrayUtil } from "../../../util/collection/ArrayUtil";
import { AbstractPanelLayout } from "./AbstractPanelLayout";
/**
 * ManualLayout.ts
 */
export class ManualLayout extends AbstractPanelLayout {
    constructor(positions = []) {
        super();
        this.positions = positions;
    }
    equals(other) {
        return super.equals(other) &&
            ArrayUtil.equals(this.positions, other.positions);
    }
    apply(children) {
        if (children.length) {
            this.positions.forEach((position, index) => {
                this.addChild(children[index], position);
            });
        }
    }
    clone() {
        return new ManualLayout(this.positions);
    }
}
//# sourceMappingURL=ManualLayout.js.map